import { useSearchParams } from "react-router-dom";
import { Alert } from "reactstrap";
import { useState } from "react";

import { BrieGPTTabs } from "./BrieGPTSidebarElements/Types";
import { newToastEvent } from "../../../utils/ToastUtil";
import { DrawerProps } from "../../Drawers/DrawerTypes";
import useCreateProject from "./useCreateProject";
import { BrieTypeProps } from "./BrieGPTSidebar";
import AppModal from "../../Modals/AppModal";
import AppInput from "../../AppInput";

type Props = DrawerProps & BrieTypeProps & { tab: BrieGPTTabs };

export default function NewProjectModal({
  open,
  onClose,
  tab,
  ...brieTypeProps
}: Props) {
  const { createProject } = useCreateProject(tab);
  const [error, setError] = useState("");
  const [projectName, setProjectName] = useState("");
  const [params, setParams] = useSearchParams();

  return (
    <AppModal
      open={open}
      onClose={handleClose}
      title="New Brie GPT Project"
      content={
        <>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              onCreateProject();
            }}
          >
            <h3 className="tw:-mt-3">Project Name</h3>
            <AppInput
              autoFocus
              value={projectName}
              onChange={(e) => setProjectName(e.target.value)}
            />
            <div className="tw:text-sm tw:text-dark tw:bg-superlight tw:p-2 tw:border tw:border-gray-300 tw:rounded tw:mt-3">
              Projects serve as dedicated hubs for managing conversations,
              storing files, and setting custom guidelines. Whether you're
              working on long-term tasks or simply keeping things organized,
              they help you stay structured and efficient.
            </div>
            {error && (
              <Alert color="danger" className="tw:py-2 tw:mt-4 tw:mb-0">
                {error}
              </Alert>
            )}
          </form>
        </>
      }
      cancelButtonText="Close"
      confirmButtonText="Create"
      onConfirm={onCreateProject}
      submitting={false}
      disabled={false}
    />
  );

  function handleClose() {
    onClose();
    setProjectName("");
    setError("");
  }

  async function onCreateProject() {
    setError("");

    createProject({
      projectName: projectName,
      ...brieTypeProps,
      onSuccess: (projectID) => {
        // Navigate to the new project
        params.set("projectID", projectID);
        setParams(params);

        handleClose();
        newToastEvent("success", "Project created successfully.");
      },
      onError: (err) => {
        setError(err);
      },
    });
  }
}
